/**
 * Panel marketing del lado izquierdo de /login · degradado lineal vertical
 * naranja (tono más suave arriba → naranjas más fuertes y oscuros hacia
 * abajo), el nombre del portal en grande al centro y footer con copyright.
 * Sin logotipo. Solo visible en md+.
 */
export function LoginMarketingPanel() {
  return (
    <div className="relative hidden h-full overflow-hidden p-8 text-white md:block" style={{ backgroundImage: BACKGROUND }}>
      <div className="relative z-[1] flex h-full flex-col justify-between">
        <div />
        <div className="multiva-fade-up mx-auto" style={{ width: "min(78%, 520px)" }}>
          {/* Blanco PLENO + semibold + sombra sutil · asegura legibilidad sobre el degradado variable. */}
          <h2
            className="font-semibold leading-tight"
            style={{
              fontSize: "clamp(32px, 3.6vw, 52px)",
              letterSpacing: -0.5,
              textShadow: "0 1px 3px rgba(0,0,0,0.28)",
            }}
          >
            Portal de proveedores
          </h2>
        </div>
        <p className="text-xs" style={{ opacity: 0.55 }}>
          © {new Date().getFullYear()} Portal de proveedores
        </p>
      </div>
    </div>
  );
}

// Degradado lineal vertical · naranja base (`multiva-600`, el tono más suave)
// arriba, intensificándose a naranjas más fuertes/oscuros (`700 → 800`) hacia
// abajo.
const BACKGROUND =
  "linear-gradient(180deg, var(--color-multiva-600) 0%, var(--color-multiva-700) 55%, var(--color-multiva-800) 100%)";
